export * from './ProductInfoSetting';
export { ProductInfoSetting as default } from './ProductInfoSetting';
